import SquareIcon from '@mui/icons-material/Square'
import { TableCell, TableRow, Typography, useMediaQuery } from '@mui/material'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import { map } from 'lodash'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { CoinLabel } from '../../../../../components/CoinLabel'
import { useProfileStore } from '../../../../../store/storeProfile'
import { theme } from '../../../../../theme'
import { ModelIcon } from '../../../MainPage/components/ModelIcon'
import { BillingStatus } from './BillingStatus'
import { BillingTableHeading } from './BillingTableHeading'
import { getSpentColumns, getSpentMobileColumns } from './constants'

export const BillingSpentTable = ({}) => {
    const { t } = useTranslation()
    const { billingListSpent } = useProfileStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const ts = Intl.DateTimeFormat().resolvedOptions().timeZone

    return (
        <>
            {isMobile ? (
                <Stack>
                    {map(billingListSpent?.objects, (billing) => {
                        return (
                            <Stack direction="column" spacing={1} py={1}>
                                <Stack
                                    direction="row"
                                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                    {billing?.data?.command && (
                                        <Stack
                                            direction="row"
                                            spacing={0.5}
                                            sx={{
                                                alignItems: 'center',
                                                background: '#F4F4F6',
                                                borderRadius: '6px',
                                                padding: '4px 6px',
                                            }}>
                                            <ModelIcon agentKey={billing?.data?.command} />
                                            <Typography variant="caption2">
                                                {billing?.data?.command}
                                            </Typography>
                                        </Stack>
                                    )}
                                    {billing?.balance_charge === 0 ? (
                                        <Typography
                                            variant="caption1"
                                            sx={{
                                                fontWeight: '500',
                                                fontSize: '10px',
                                            }}>
                                            Бесплатно для вас!
                                        </Typography>
                                    ) : (
                                        <>
                                            -<CoinLabel coin={billing?.balance_charge} />
                                        </>
                                    )}
                                </Stack>
                                <Typography
                                    component="p"
                                    variant="caption2"
                                    sx={{
                                        textAlign: 'left',
                                        color: '#9195A1',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                    {billing?.source}
                                </Typography>
                                <Stack direction="row" sx={{ alignItems: 'center' }}>
                                    <SquareIcon
                                        sx={{
                                            fontSize: '10px',
                                            color: '#006CFD',
                                            marginRight: '4px',
                                        }}
                                    />

                                    <Typography
                                        variant="caption1"
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: '#121317',
                                            fontSize: '10px',
                                        }}>
                                        {billing?.data?.workplace}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                                    <Typography variant="caption2">
                                        {billing?.created_at &&
                                            moment(billing?.created_at)
                                                .tz(ts)
                                                .format('DD.MM.YY HH:mm')}
                                    </Typography>
                                    <BillingStatus status={billing?.change_status} />
                                </Stack>
                                <Divider />
                            </Stack>
                        )
                    })}
                </Stack>
            ) : (
                <Table stickyHeader aria-label="sticky table">
                    {billingListSpent && (
                        <>
                            <>
                                <BillingTableHeading
                                    columns={isMobile ? getSpentMobileColumns(t) : getSpentColumns(t)}
                                />
                                <TableBody>
                                    {billingListSpent?.objects?.map((billing) => {
                                        return (
                                            <TableRow key={billing?.filename}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    sx={{
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        cursor: 'pointer',
                                                    }}>
                                                    <Stack direction="column" sx={{}} spacing={1}>
                                                        {billing?.data?.command && (
                                                            <Stack spacing={0.5} direction="row">
                                                                <Paper
                                                                    sx={{
                                                                        alignItems: 'center',
                                                                        background: '#F4F4F6',
                                                                        display: 'flex',
                                                                        borderRadius: '6px',
                                                                        padding: '4px 6px',
                                                                    }}>
                                                                    <ModelIcon
                                                                        agentKey={
                                                                            billing?.data?.command
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        variant="caption2"
                                                                        sx={{ ml: '4px' }}>
                                                                        {billing?.data?.command}
                                                                    </Typography>
                                                                </Paper>
                                                            </Stack>
                                                        )}

                                                        <Typography
                                                            variant="caption2"
                                                            sx={{
                                                                maxWidth: `calc(100dvw - ${840}px)`,
                                                                color: '#9195A1',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}>
                                                            {billing?.source}
                                                        </Typography>

                                                        {billing?.data?.workplace && (
                                                            <Stack
                                                                direction="row"
                                                                sx={{ alignItems: 'center' }}>
                                                                <SquareIcon
                                                                    sx={{
                                                                        fontSize: '10px',
                                                                        color: '#006CFD',
                                                                        marginRight: '4px',
                                                                    }}
                                                                />

                                                                <Typography
                                                                    variant="caption1"
                                                                    sx={{
                                                                        maxWidth: `calc(100dvw - ${840}px)`,
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        color: '#121317',
                                                                        fontSize: '10px',
                                                                    }}>
                                                                    {billing?.data?.workplace}
                                                                </Typography>
                                                            </Stack>
                                                        )}
                                                    </Stack>
                                                </TableCell>

                                                <TableCell>
                                                    <BillingStatus
                                                        status={billing?.change_status}
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {billing?.created_at &&
                                                        moment(billing?.created_at)
                                                            .tz(ts)
                                                            .format('DD.MM.YY HH:mm')}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {billing?.balance_charge === 0 ? (
                                                        <Typography
                                                            variant="caption1"
                                                            sx={{
                                                                fontWeight: '500',
                                                                fontSize: '10px',
                                                            }}>
                                                            {t('finances.freeForYou')}
                                                        </Typography>
                                                    ) : (
                                                        <>
                                                            -
                                                            <CoinLabel
                                                                coin={billing?.balance_charge}
                                                            />
                                                        </>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </>
                        </>
                    )}
                </Table>
            )}
        </>
    )
}
